// Lib
import React, { ReactElement } from 'react';

// Utils
import { getElementId, getTextContent } from '../../../common/elements/utils/elementPropertyUtils';

// Hooks
import { useElementTiptapContent } from '../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import CardTiptapEditor from './tiptap/CardTiptapEditor';

// Types
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { DocumentType } from '../../../common/tiptap/conversion/elementConversion/elementConversion';
import { SaveTiptapEditorContentFunction } from '../../../common/tiptap/extensions/externalStoreSync/externalStoreSynchroniserTypes';

export interface CardEditorProps {
    element: ImMNElement;
    isEditing: boolean;
    isEditable: boolean;
    isSingleSelected: boolean;
    isFocusedForegroundElement: boolean;
    currentEditorId: string;
    editorRef: (editor: HTMLDivElement | null) => void;
    saveContent: SaveTiptapEditorContentFunction;
    startEditing: () => void;
    moveElementsToTrash: () => void;
    createNewCard: () => void;
}

const CardEditor = (props: CardEditorProps): ReactElement => {
    const {
        element,
        currentEditorId,
        isEditable,
        isEditing,
        isSingleSelected,
        isFocusedForegroundElement,
        saveContent,
        startEditing,
        editorRef,
        moveElementsToTrash,
        createNewCard,
    } = props;

    const textContent = getTextContent(element);
    const elementId = getElementId(element);
    const tiptapContent = useElementTiptapContent(textContent, elementId, DocumentType.textContent);

    return (
        <CardTiptapEditor
            element={element}
            textContent={tiptapContent}
            currentEditorId={currentEditorId}
            isEditable={isEditable}
            isEditing={isEditing}
            isSingleSelected={isSingleSelected}
            isFocusedForegroundElement={isFocusedForegroundElement}
            saveContent={saveContent}
            startEditing={startEditing}
            editorRef={editorRef}
            moveElementsToTrash={moveElementsToTrash}
            createNewCard={createNewCard}
        />
    );
};

export default CardEditor;
